export default __webpack_public_path__ + "static/media/Collective-arts.82349776.jpg";